export default "__VITE_ASSET__BIVSwD$u__"